import { render, staticRenderFns } from "./TireChange.vue?vue&type=template&id=643b68d9&"
import script from "./TireChange.vue?vue&type=script&lang=js&"
export * from "./TireChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports